import { Asset } from '@/types/assets';

// Treat Electric for Desktop as installed when OSQuery enrollment is present.
export function getWasElectricAppInstalledOnDevice(
  deviceAsset: Asset
): boolean {
  return !!deviceAsset.device?.reportingData?.lastOsqueryEnrollment;
}

// Similar to the above, this is how we determine whether MDM is on a device.
// NOTE: Throughout our application, we only count MDM as "really installed" if
// there's an employee association.

export function getWasMDMInstalledOnDevice(deviceAsset: Asset): boolean {
  return !!deviceAsset.device?.mdmEnrolledAt;
}
